import { configureStore } from "@reduxjs/toolkit";

import auth from "./authSlice";
import categories from "./categoriSlice";
import ingredienSlice from "./ingredienSlice";
import productSlice from "./productSlice";
import clientSlice from "./clientSlice";
import orderSlice from "./orderSlice";
import settingSlice from "./settingSlice";
import deliveryFeeRangesSlice from "./deliveryFeeRangesSlice";
import pizzaDoughSlice from "./pizzaDoughSlice";
import pizzaBaseSlice from "./pizzaBaseSlice";

const store = configureStore({
  reducer: {
    auth,
    categories,
    ingredients: ingredienSlice,
    products: productSlice,
    clients: clientSlice,
    orders: orderSlice,
    settings: settingSlice,
    deliveryFeeRanges: deliveryFeeRangesSlice,
    pizzaDough: pizzaDoughSlice,
    pizzaBase: pizzaBaseSlice,
  },
});
export default store;
